/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbRespContentModuleRegular_browseContentModule$ref = any;
export type SbRespContentModuleRegular_browseContentModule = {
    readonly description: string | null;
    readonly title: string | null;
    readonly photo: string | null;
    readonly " $refType": SbRespContentModuleRegular_browseContentModule$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespContentModuleRegular_browseContentModule",
    "type": "ContentModuleRegular",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "photo",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '6b5cff918be84a3cba8fb2b60113f7de';
export default node;
